function toast(msg) {
  const el = document.querySelector("[data-toast]");
  if (!el) return;
  el.textContent = msg;
  el.hidden = false;
  setTimeout(() => { el.hidden = true; }, 2200);
}

async function fetchCart() {
  const res = await fetch("/cart.js");
  return res.json();
}

function formatMoney(cents) {
  return "$" + (cents / 100).toFixed(2);
}

async function renderCart() {
  const cart = await fetchCart();
  const count = cart.item_count || 0;
  document.querySelectorAll("[data-cart-count]").forEach((el) => {
    el.textContent = String(count);
  });

  const list = document.querySelector("[data-cart-items]");
  const empty = document.querySelector("[data-cart-empty]");
  const total = document.querySelector("[data-cart-total]");
  if (!list) return;

  list.innerHTML = cart.items.map((item) => {
    const planName = item.selling_plan_allocation?.selling_plan?.name;
    const variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
    const meta = [variant, planName, formatMoney(item.final_line_price)].filter(Boolean).join(" · ");
    return `
    <div class="cart-item">
      <img src="${item.image}" alt="">
      <div>
        <strong>${item.product_title}</strong>
        <div class="dim">${meta}</div>
        <button type="button" data-remove-line="${item.key}" style="background:none;border:0;color:#a89b80;padding:0;margin-top:6px;">Remove</button>
      </div>
      <div>${item.quantity}</div>
    </div>`;
  }).join("");

  if (empty) empty.hidden = count > 0;
  if (total) {
    total.hidden = count === 0;
    const subEl = document.querySelector("[data-subtotal]");
    if (subEl) subEl.textContent = formatMoney(cart.total_price);
  }
}

async function addToCart(variantId, quantity = 1, sellingPlanId = null) {
  const item = { id: Number(variantId), quantity: Number(quantity) };
  if (sellingPlanId) item.selling_plan = Number(sellingPlanId);

  const res = await fetch(window.routes.cart_add_url + ".js", {
    method: "POST",
    headers: { "Content-Type": "application/json", Accept: "application/json" },
    body: JSON.stringify({ items: [item] }),
  });

  if (!res.ok) {
    const err = await res.json();
    toast(err.description || "Could not add to bag");
    return;
  }

  await renderCart();
  document.querySelector("[data-drawer]")?.classList.add("open");
  toast("Added to bag");
}

function appstleWidgetPresent(root) {
  return !!root?.querySelector(
    ".appstle_sub_widget, [id^='appstle_subscription_widget'], #appstle-widget-template"
  );
}

function yieldToAppstle(form) {
  if (!form || !appstleWidgetPresent(form)) return false;
  form.classList.add("has-appstle-widget");
  const box = form.querySelector("[data-theme-subscribe]");
  const input = form.querySelector("[data-selling-plan-input]");
  if (box) box.hidden = true;
  if (input) input.disabled = true;
  return true;
}

function bindThemeSubscribe(form) {
  const box = form.querySelector("[data-theme-subscribe]");
  if (!box || form.dataset.themeSubscribeBound) return;
  form.dataset.themeSubscribeBound = "true";

  const input = form.querySelector("[data-selling-plan-input]");
  const freq = box.querySelector("[data-sub-frequency]");
  const subPrice = box.querySelector("[data-sub-price]");
  const data = readSellingPlanData(form);

  function selectedPlanId() {
    const choice = box.querySelector("[name='purchase_choice']:checked")?.value;
    if (choice !== "subscribe") return "";
    if (freq?.value) return freq.value;
    return input?.value || "";
  }

  function apply() {
    if (yieldToAppstle(form)) {
      syncProductPrice(form);
      return;
    }
    const planId = selectedPlanId();
    if (input) {
      input.disabled = false;
      input.value = planId;
    }
    box.querySelectorAll(".subscribe-box__option").forEach((opt) => {
      opt.classList.toggle("is-selected", !!opt.querySelector("input:checked"));
    });
    if (data && subPrice && planId) {
      const alloc = data.allocations?.find((a) => String(a.id) === String(planId));
      if (alloc) subPrice.textContent = formatMoneyFromCents(alloc.price);
    }
    syncProductPrice(form);
  }

  box.addEventListener("change", apply);
  apply();
}

function getSellingPlanId(form) {
  if (!form) return null;
  const checked = form.querySelector("[name='selling_plan']:checked");
  if (checked) return checked.value || null;
  const named = [...form.querySelectorAll("[name='selling_plan']")];
  for (const input of named) {
    if (input.disabled) continue;
    if (input.matches("select") && input.value) return input.value;
    if (input.type === "hidden" && input.value) return input.value;
  }
  return null;
}

function readSellingPlanData(form) {
  const el = form?.querySelector("[data-selling-plan-data]");
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch {
    return null;
  }
}

function formatMoneyFromCents(cents) {
  if (typeof cents !== "number" || Number.isNaN(cents)) return "";
  return formatMoney(cents);
}

function syncProductPrice(form) {
  if (!form) return;
  const data = readSellingPlanData(form);
  const addBtn = form.querySelector("[data-add]");
  if (addBtn && !addBtn.dataset.listPrice) addBtn.dataset.listPrice = addBtn.dataset.price || "";
  const listPrice = addBtn?.dataset.listPrice || addBtn?.dataset.price || "";
  let formatted = listPrice;

  if (data) {
    const planId = getSellingPlanId(form);
    const alloc = data.allocations?.find((a) => String(a.id) === String(planId));
    formatted = alloc ? formatMoneyFromCents(alloc.price) : formatMoneyFromCents(data.price) || listPrice;
  }

  if (!formatted) return;
  form.closest(".buy")?.querySelectorAll(".price-item--regular").forEach((el) => {
    el.textContent = formatted;
  });
  document.querySelectorAll("[data-sticky-price]").forEach((el) => {
    el.textContent = formatted;
  });
  if (addBtn) addBtn.dataset.price = formatted;
}

function bindSellingPlanPrice(form) {
  if (!form || form.dataset.sellingPlanBound) return;
  form.dataset.sellingPlanBound = "true";

  const sync = () => syncProductPrice(form);
  form.addEventListener("change", sync);
  form.addEventListener("input", sync);

  [
    "AppstleSubscription:SubscriptionWidget:widgetInitialised",
    "AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated",
    "AppstleSubscription:SubscriptionWidget:SellingPlanSelected",
    "AppstleSubscription:SubscriptionWidget:SellingPlanDeSelected",
    "AppstleSubscription:SubscriptionWidget:sellingPlanChanged",
  ].forEach((eventName) => {
    document.addEventListener(eventName, sync);
  });

  const observer = new MutationObserver(() => {
    yieldToAppstle(form);
    sync();
  });
  observer.observe(form, { childList: true, subtree: true });
  [
    "AppstleSubscription:SubscriptionWidget:widgetInitialised",
    "AppstleSubscription:SubscriptionWidget:SubscriptionWidgetUpdated",
  ].forEach((eventName) => {
    document.addEventListener(eventName, () => yieldToAppstle(form));
  });
  yieldToAppstle(form);
  sync();
}

function mountStickyBuy() {
  const buy = document.querySelector(".buy");
  const addBtn = buy?.querySelector("[data-add]");
  if (!buy || !addBtn) return;

  const bar = document.createElement("div");
  bar.className = "sticky-buy";
  bar.innerHTML = `
    <div class="sticky-buy-inner">
      <div class="sticky-buy-info">
        <strong>${addBtn.dataset.name || "Product"}</strong>
        <span data-sticky-price>${addBtn.dataset.price || ""}</span>
      </div>
      <button class="btn btn-gold" type="button" data-sticky-add>Add to bag</button>
    </div>`;
  document.body.appendChild(bar);

  const stickyAdd = bar.querySelector("[data-sticky-add]");
  const form = buy.querySelector("[data-product-form]") || buy;
  bindSellingPlanPrice(form);

  stickyAdd.addEventListener("click", () => addBtn.click());

  const observer = new IntersectionObserver(
    ([entry]) => {
      const show = !entry.isIntersecting;
      bar.classList.toggle("visible", show);
      document.body.classList.toggle("has-sticky-buy", show);
    },
    { threshold: 0, rootMargin: "0px 0px -80px 0px" }
  );
  observer.observe(addBtn);
}

function bindProductForms() {
  document.querySelectorAll("[data-product-form]").forEach((form) => {
    bindThemeSubscribe(form);
    bindSellingPlanPrice(form);
    form.addEventListener("submit", async (e) => {
      e.preventDefault();
      const variantId = form.querySelector("[name='id']")?.value;
      const qty = form.querySelector("[name='quantity']")?.value || 1;
      const sellingPlanId = getSellingPlanId(form);
      if (!variantId) return;
      await addToCart(variantId, qty, sellingPlanId);
    });
  });
}

document.addEventListener("click", async (e) => {
  if (e.target.closest("[data-cart]")) {
    document.querySelector("[data-drawer]")?.classList.add("open");
    await renderCart();
  }
  if (e.target.closest("[data-close-cart]") || e.target.matches("[data-drawer]")) {
    document.querySelector("[data-drawer]")?.classList.remove("open");
  }
  if (e.target.closest("[data-menu]")) {
    document.querySelector("[data-mobile]")?.classList.toggle("open");
  }
  const checkout = e.target.closest("[data-checkout]");
  if (checkout) {
    window.location.href = window.routes.checkout_url || "/checkout";
  }
  const rem = e.target.closest("[data-remove-line]");
  if (rem) {
    const key = rem.getAttribute("data-remove-line");
    await fetch(window.routes.cart_change_url + ".js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    await renderCart();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  renderCart();
  mountStickyBuy();
  bindProductForms();
});
